import { createFileRoute } from '@tanstack/react-router';
import Organizations from 'containers/Organizations';

export const Route = createFileRoute('/_authenticated/organizations')({
  component: Organizations,
});
